/**Dependencies */
import React, {useState, useEffect} from 'react';

/**Styles */
import '../styles/home.scss'

/**Images */
import { IoIosArrowDropup } from "react-icons/io";

/**Componente para mostrar el icono de ir hacia el tope de la página*/
export const ScrollToTop = () => {
    const [ showGoTop, setShowGoTop ] = useState( false )

    const handleVisibleButton = () => {
        setShowGoTop( window.pageYOffset > 300 )
    }

    const scrollToTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      };

    useEffect( () => {
        window.addEventListener( 'scroll', handleVisibleButton )
    }, [] )

  return (
    <div className={`scroll-up ${showGoTop ? '' : 'show-scroll'}`} style={{cursor:"pointer"}}>
        <IoIosArrowDropup  onClick={scrollToTop} style={{paddingTop:"5px"}}/>
    </div>
  )
}
